import { TranslateService } from "@ngx-translate/core";
import { Component, Input, OnInit } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { UserService } from "src/app/_services";
import { ThisPlatform } from "src/app/_services/platform.service";
import { UserBasic } from "src/app/_models/user.model";

@Component({
  selector: "app-select-modal-user",
  templateUrl: "./select-modal-user.component.html",
  styleUrls: ["./select-modal-user.component.scss"],
})
export class SelectModalUserComponent implements OnInit {
  @Input()
  label: string;

  @Input()
  filtrIdCompany: number;

  @Input()
  removeCurrentUserFromList: boolean = false;
  
  headerText: string;

  user: UserBasic;

  noUserError: boolean = false;

  constructor(
    public userService: UserService,
    private modalCtrl: ModalController,
    public p: ThisPlatform,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.headerText = this.translate.instant(this.label);
  }

  setUser(user) {

    if(user.length === 0){
      this.noUserError = true;
      this.user = null;
    } else {
      this.noUserError = false;
      this.user = user;

    }
  }

  save() {
    if (this.user) {
      this.modalCtrl.dismiss(this.user);
    } else {
      this.noUserError = true;
    }
  }

  back() {
    this.modalCtrl.dismiss(undefined, "backdrop");
  }
}
